import React from 'react';
import { Container } from '@fiverr-private/layout_components';
import { TEXTAREA_SLOT_ID } from '../../constants';
import { TextareaSlotProps } from './types';

const TextareaSlot = ({
  children,
  position: _position,
  dataTrackTag = 'textarea_slot',
  ...restProps
}: TextareaSlotProps) => (
  <Container dataTrackTag={dataTrackTag} {...restProps}>
    {children}
  </Container>
);

TextareaSlot.id = TEXTAREA_SLOT_ID;
export default TextareaSlot;
